import { IconProps } from ".";
import Icon from "./assets/chevron_right_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChevronRight(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
